export const requestAllowanceScript = `
-- Parameters: key (stores current allowance), args (max allowance, interval, requested allowance)

-- Function to get the current allowance
local function getCurrentAllowance(key, maxAllowance, interval)
  local allowance = redis.call('GET', key)
  if allowance then
    return tonumber(allowance)
  else
    -- Set initial allowance to maxAllowance with a TTL of interval
    redis.call('SET', key, maxAllowance, 'EX', interval)
    return maxAllowance
  end
end

-- Main
local key = KEYS[1]
local maxAllowance = tonumber(ARGV[1])
local interval = tonumber(ARGV[2])
local requestedAllowance = tonumber(ARGV[3])
local currentAllowance = getCurrentAllowance(key, maxAllowance, interval)

-- Determine the allowance to be claimed
local claimedAllowance = math.min(currentAllowance, requestedAllowance)

-- Decrement the key by the claimed allowance
redis.call('DECRBY', key, claimedAllowance)

-- Get the TTL of the key
local ttl = redis.call('TTL', key)

-- Return the claimed allowance and the TTL
return { claimedAllowance, ttl }`;
